"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { createTheme, MantineProvider } from "@repo/ui/mantine";
import { Provider as JotaiProvider } from "jotai";
const aopsMantineTheme = createTheme({
  fontFamily: "var(--body-md-typeface), sans-serif",
  headings: {
    fontFamily: "var(--display-primary), serif"
  }
});
export function Providers(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <JotaiProvider><MantineProvider theme={aopsMantineTheme}>{children}</MantineProvider></JotaiProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}